
import moment from 'moment';
import { NDescriptions, NDescriptionsItem } from 'naive-ui';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';
import ChartStationEvents from '~/components/chart-station-events/chart-station-events.vue';

import ComponentBase from '~/components/component-base';
import { NetworkIndicator } from '~/components/device-list-item/device-list-item';
import DeviceStatusDisplay from '~/components/device-status-display/device-status-display.vue';
import IndicatorRuntime from '~/components/indicator-runtime/indicator-runtime.vue';
import StationEventsTimeline from '~/components/station-events-timeline/station-events-timeline.vue';
import WidgetIndicator from '~/components/widget-indicator/widget-indicator.vue';
import { AvoltaAlarm, AvoltaAlarmEnum } from '~/configs/alarms/avolta-alarm.model';
import { AvoltaIndicator } from '~/configs/indicators/avolta-indicators.config';
import { getStationAlarm } from '~/misc/station-utils';


import { useStationDetailStore } from '~/store/station-details.store';
import { dangerColor, greenColor, orangeColor, successColor, warningColor, whiteColor } from '~/variables';


export default defineComponent({

    extends: ComponentBase,

    components: {
        NDescriptions,
        NDescriptionsItem,

        DeviceStatusDisplay,
        StationEventsTimeline,
        ChartStationEvents,
        IndicatorRuntime,
        WidgetIndicator,
    },

    data() {
        return {
            dangerColor,
            warningColor,
            successColor,
            networkRepresentation: {
                '-1': { value: -1, icon: 'elichens-avolta elichens-signal-0', label: this.$t('global.network.offline'), color: orangeColor, tooltip: this.$t('global.network.offline_description') },
                '0': { value: 0, icon: 'elichens-avolta elichens-signal-1', label: this.$t('global.network.poor'), color: orangeColor, tooltip: this.$t('global.network.poor_description') },
                '1': { value: 1, icon: 'elichens-avolta elichens-signal-2', label: this.$t('global.network.average'), color: orangeColor, tooltip: this.$t('global.network.average_description') },
                '2': { value: 2, icon: 'elichens-avolta elichens-signal-2', label: this.$t('global.network.average'), color: orangeColor, tooltip: this.$t('global.network.average_description') },
                '3': { value: 3, icon: 'elichens-avolta elichens-signal-3', label: this.$t('global.network.good'), color: greenColor, tooltip: this.$t('global.network.good_description') },
                '4': { value: 4, icon: 'elichens-avolta elichens-signal-4', label: this.$t('global.network.very_good'), color: greenColor, tooltip: this.$t('global.network.very_good_description') },
            } as { [value: number]: NetworkIndicator }
        }
    },

    computed: {
        ...mapState(useStationDetailStore, ['station', 'since', 'before', 'measures', 'events']),

        network(): NetworkIndicator {
            const networkQuality: number = this.station?.latest_values?.['network_quality'] as number;
            if (networkQuality === undefined) {
                return null;
            }

            return this.networkRepresentation[networkQuality] ||  null;
        },

        
        ppm(): number {
            return this.station?.latest_values?.[AvoltaIndicator.CH4] as number || 0;
        },

        ppmColor(): string {
            if(this.lel >= 40000) {
                return dangerColor;
            } else if(this.lel >= 5000) {
                return warningColor;
            } else {
                return whiteColor;
            }
        },

        lel(): number {
            return this.station?.latest_values?.[AvoltaIndicator.CH4_lel] as number || 0;
        },

        lelColor(): string {
            if(this.lel >= 80) {
                return dangerColor;
            } else if(this.lel >= 10) {
                return warningColor;
            } else {
                return whiteColor;
            }
        },

        temperature(): number {
            if(!this.station?.latest_values?.temperature) {
                return 0;
            }

            return this.station?.latest_values?.temperature as number;
        },

        humidity(): number {
            if(!this.station?.latest_values?.humidity) {
                return 0;
            }

            return this.station?.latest_values?.humidity as number;
        },

        status(): AvoltaAlarm {
            return getStationAlarm(this.station) || { color: greenColor, label: this.$t('global.ok'), short: this.$t('global.ok'), icon: 'mdi mdi-check', name: 'ok' as AvoltaAlarmEnum};
        },

        runtime(): string {
            if(this.station?.latest_values?.run_time !== undefined) {
                const duration = moment.duration(this.station.latest_values.run_time, 'hours');
                const months = duration.months()
                const days = duration.days();
                const hours = duration.hours();
                return `${months ? this.$t('time.n-month_short', months): ''}  ${days ? this.$t('time.n-day_short', days): ''} ${this.$t('time.n-hour_short', hours)}`;
            } else {
                return '-'
            }
        },

        inPPM(): boolean {
            return this.isAvolta50(this.station);
        }
     }
});